// 生成图片对象的函数
export const createImageObject = ({
    url = '',
    specialOrgUrl = '',
    taskId = 0,
    templateId = 0,
    recordId = 0,
    width = 0,
    height = 0,
    ratioNum = null,
    checked = false,
    editorParams = '',
    ext = '{}',
    templateData = {}
}) => {
    return {
        url,
        specialOrgUrl,
        taskId,
        templateId,
        recordId,
        width,
        height,
        ratioNum,
        checked,
        editorParams,
        ext,
        templateDetail: templateData.templateDetail || {}
    };
};
